import React from 'react';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import type { PrototypeLink } from './SiteFooter';
interface PageShellProps {
  mode: 'guest' | 'member';
  onStart: () => void;
  startLabel: string;
  onSignIn: () => void;
  onSignOut: () => void;
  banner?: React.ReactNode;
  prototypeLinks?: PrototypeLink[];
  children: React.ReactNode;
}
export function PageShell({
  mode,
  onStart,
  startLabel,
  onSignIn,
  onSignOut,
  banner,
  prototypeLinks,
  children
}: PageShellProps) {
  return <div id="top" className="flex min-h-screen w-full flex-col bg-canvas" data-id="element-240" data-mp="c568b4tdgida">
      <SiteHeader mode={mode} onStart={onStart} startLabel={startLabel} onSignIn={onSignIn} onSignOut={onSignOut} data-id="element-241" data-mp="qsr8apuya1gz" />
      {banner}
      <main className="flex-1" data-id="element-242" data-mp="3uhcjajr2obq5">{children}</main>
      <SiteFooter prototypeLinks={prototypeLinks} data-id="element-243" data-mp="3ug1fijxmn3z1" />
    </div>;
}